import { STORAGE_KEYS, STORAGE_TYPES } from "@Constants/storage";
import { IRecipesDetailPageContent } from "@Types/recipes-detail-page";
import { getItem } from "@Utils/browserStorage";
import { isCanadianLocale } from "@Utils/locale";
import { useAppSelector } from "@wff/store/hooks";
import { ZipCodeSelector } from "@wff/store/zipcodeSlice";
import { CookingDirections } from "./CookingDirections";
import { Header } from "./Header";
import { IngredientList } from "./IngredientList";
import classes from "./RecipesDetail.module.scss";

interface RecipesDetailLayoutProps extends IRecipesDetailPageContent {}

export const RecipesDetailLayout = (props: RecipesDetailLayoutProps) => {
  const { languageCode } = useAppSelector(({ locale }) => locale);
  const isCanadianUser = isCanadianLocale(languageCode);
  const { availability, isPickupAvailable } = useAppSelector(ZipCodeSelector);

  const currentZipCodeAvialabilityStoreIdInStorageForCA = getItem(
    STORAGE_KEYS.CUSTOMER_ZIP_AVAILABILITY_CA,
    STORAGE_TYPES.LOCAL
  );

  const currentZipCodePickupAvailabilityForCA = getItem(
    STORAGE_KEYS.CUSTOMER_ZIP_AVAILABILITY_CA,
    STORAGE_TYPES.LOCAL
  );

  //CA-ONLY
  if (isCanadianUser) {
    props = {
      ...props,
      isCanadianUser,
      availability,
      isPickupAvailable,
      currentZipCodeAvialabilityStoreIdInStorageForCA,
      currentZipCodePickupAvailabilityForCA,
    };
  }

  return (
    <div className={classes["recipes-detail-page"]}>
      <Header {...props} />
      <section className={classes["recipe-section"]}>
        <IngredientList {...props} />
        <div className={classes["divider"]} />
        <CookingDirections {...props} />
      </section>
    </div>
  );
};
